export { default } from '@shikijs/langs/typescript'
